<template>
  <div class="">
    <SaveTemplate/>
  </div>
  
</template>

<script>
// @ is an alias to /src
import SaveTemplate from '@/components/SaveTemplate.vue'


export default {
  name: 'Home',
  props:['idreservation'],
  components: {
    SaveTemplate,
  }
}
</script>
